angular.module('impactx.cancellation').controller('CancelConditionCheckResultCtrl', CancelConditionCheckResultCtrl);

CancelConditionCheckResultCtrl.$inject = ['$mdDialog', 'TranslationService', 'message', 'question', 'requestCancel', 'requestItems'];

function CancelConditionCheckResultCtrl($mdDialog, TranslationService, message, question, requestCancel, requestItems)
{
    var ctrl = this;

    ctrl.message = message;
    ctrl.question = question;
    ctrl.saveLabel = requestCancel;
    ctrl.abortLabel = TranslationService.get('abort');
    ctrl.entries = [];
    
    for(var key in requestItems) {
        if (requestItems.hasOwnProperty(key)) {
            ctrl.entries.push(requestItems[key])
        }
    }
    
    ctrl.save = function () {
        $mdDialog.hide();
    };
    
    ctrl.cancel = function () {
        $mdDialog.cancel()
    }
}